export const normalizePath = (path) => path.split(/[?#]/)[0].replace(/\/+$/, "") || "/";
export function groupFor(path, manifest) {
  const clean = normalizePath(path);
  return manifest.groups.find((group) => Object.values(group).includes(clean));
}
export function languageTarget(path, language, manifest) {
  const clean = normalizePath(path);
  const current = manifest.languages.includes(clean.split("/")[1]) ? clean.split("/")[1] : "he";
  if (current === language) return clean;
  return groupFor(path, manifest)?.[language] || (language === "he" ? "/" : `/${language}`);
}
export function retiredTarget(path, manifest) {
  const clean = normalizePath(path);
  const prefix = clean.split("/")[1];
  if (!manifest.retired.includes(prefix)) return null;
  const base = clean.replace(/^\/[^/]+/, "") || "/";
  const candidate = base === "/" ? "/en" : `/en${base}`;
  return manifest.groups.some((group) => group.en === candidate) ? candidate : "/en";
}
export function alternateEntries(path, manifest) {
  const group = groupFor(path, manifest);
  const clean = normalizePath(path);
  const prefix = clean.split("/")[1];
  const language = manifest.languages.includes(prefix) ? prefix : "he";
  const entries = group ? Object.entries(group) : [[language, clean]];
  return [...entries.map(([lang, route]) => [`${lang}-IL`, `${manifest.origin}${route}`]), ["x-default", `${manifest.origin}/`]];
}
